<template>
  <div class="container">
    <banner />
    <div class="main">
      <Classification @upData="handleChange" />
      <el-row class="list" :gutter="20">
        <el-col class="list-item" :span="6" v-for="v in list" :key="v.id">
          <div class="card">
            <div class="card-cover" @click="handleRes(v)">
              <img
                class=""
                :src="v.bookImg"
                :title="v.bookName"
                :alt="v.bookName"
              />
            </div>
            <div class="card-info">
              <p>{{ v.bookName }}</p>
              <p>{{ v.subName }}</p>
            </div>
          </div>
        </el-col>
      </el-row>
      <div v-if="showTip" class="text-center c-808695">
        <span v-show="!list.length">暂无内容</span>
        <span v-show="list.length > 19">没有了</span>
      </div>
    </div>
  </div>
</template>

<script>
import { textbooks } from '@/api/index'
import Classification from '@/components/Classification .vue'
import Banner from './components/banner.vue'
export default {
  name: 'courses',
  components: { Classification, Banner },
  props: [],
  data() {
    return {
      list: [],
      query: {
        category_id: -1,
        modName: '',
        limit: 20,
        page: 1,
      },
      showTip: false,
    }
  },
  watch: {},
  computed: {},
  created() {
    if (this.$route.query.category || this.$route.query.category === 0) {
      this.query.category_id = this.$route.query.category
    }
    this.getList()
  },
  mounted() {
    let _this = this
    window.onscroll = function () {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      var scrollLeft =
        document.documentElement.scrollLeft || document.body.scrollLeft
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight
      var windowWidth =
        document.documentElement.clientWidth || document.body.clientWidth
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight
      var scrollWidth =
        document.documentElement.scrollWidth || document.body.scrollWidth
      if (scrollTop + windowHeight > (scrollHeight - 20) || scrollLeft + windowWidth > (scrollWidth -20)) {
        if (_this.showTip) return
        // _this.handleScrollBottom()
      }
    }
  },
  methods: {
    getList() {
      textbooks(this.query).then((res) => {
        const { data } = res
        if (data.length < 19) {
          this.showTip = true
        } else {
          this.showTip = false
        }
        if (this.query.page !== 1) {
          data.forEach((v) => {
            this.list.push(v)
          })
        } else {
          this.list = data
        }
      })
      let newurl = this.updateQueryStringParameter(
        window.location.href,
        'category',
        this.query.category_id
      )
      window.history.replaceState(
        {
          path: newurl,
        },
        '',
        newurl
      )
    },
    handleChange(id) {
      this.query.category_id = id
      this.$route.query.category = id
      this.getList()
    },
    handleScrollBottom() {
      this.query.page++
      this.getList()
    },
    handleRes(v) {
      if (!v.bookAddress || v.bookAddress[0] === '#') return
      window.localStorage.setItem('url', v.bookAddress)
      window.localStorage.setItem('title', v.bookName)
      let { href } = this.$router.resolve({ path: 'course' })
      window.open(href, '_blank')
    },
    updateQueryStringParameter(uri, key, value) {
      var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i')
      var separator = uri.indexOf('?') !== -1 ? '&' : '?'
      if (uri.match(re)) {
        return uri.replace(re, '$1' + key + '=' + value + '$2')
      } else {
        return uri + separator + key + '=' + value
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  .list {
    &-item {
      .card {
        transition: all 0.3s ease;
        display: block;
        overflow: hidden;
        &:hover {
          transform: scale(1.04);
        }
        &-cover {
          width: 100%;
          height: 0;
          padding-bottom: 140%;
          overflow: hidden;
          cursor: pointer;
          img {
            width: calc(100% - 10px);
            box-shadow: 6px 6px 5px #888;
          }
        }
        &-info {
          padding: 0 1rem;
          text-align: center;
          p {
            margin: 0;
          }
          p:first-child {
            margin-top: 0.5rem;
            text-overflow: ellipsis;
            color: #0f91e6;
            font-size: 16px;
            font-weight: 400;
          }
          p:last-child {
            font-size: 14px;
            color: #333;
          }
        }
      }
    }
  }
}
</style>
